export interface COSDisclaimerTextProps {
  localeCode: string;
}

const COSDisclaimerText = ({ localeCode }: COSDisclaimerTextProps) => {
  const getDisclaimerText1 = (localeCode: string) => {
    switch (localeCode) {
      case 'us-en':
        return `Calculated prices are estimates provided for planning purposes only taking into account potential IBM discounts and are not a formal offer from IBM or an IBM Business Partner. The estimation may reflect the total discounted price. Certain factors such as configuration, add-ons, additional requirements or related services will affect final price. IBM Business Partners set and provide their own IBM Cloud Object Storage `;
      default:
        return `Calculated prices are estimates provided for planning purposes only taking into account potential IBM discounts and are not a formal offer from IBM or an IBM Business Partner. The estimation may reflect the total discounted price. Certain factors such as configuration, add-ons, additional requirements or related services will affect final price. IBM Business Partners set and provide their own IBM Cloud Object Storage `;
    }
  };

  const getDisclaimerText2 = (localeCode: string) => {
    switch (localeCode) {
      case 'us-en':
        return `, and neither IBM nor IBM Business Partners are bound by the provided estimate.`;
      default:
        return `, and neither IBM nor IBM Business Partners are bound by the provided estimate.`;
    }
  };

  return (
    <>
      {getDisclaimerText1(localeCode)}
      <a href="https://cloud.ibm.com/objectstorage/create#pricing">pricing</a>
      {getDisclaimerText2(localeCode)}
    </>
  );
};

export default COSDisclaimerText;
